import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_public/login')({
  staticData: { team: 'users-infra' },
});
